export default function TagAICreate({
  width = 59,
  height = 28,
}: {
  width?: number
  height?: number
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 59 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="59" height="28" rx="14" fill="#F9DEB9" />
      <path
        d="M19.0991 9.41667L20.0198 18.85H17.9361L17.6938 16.2833H14.7863L13.9747 18.85H12L14.6773 9.88333L14.326 9.41667H19.0991ZM16.4218 11.0167L15.2588 14.6833H17.5848L17.2334 11.0167H16.4218Z"
        fill="black"
      />
      <path
        d="M24.4058 9.41667L23.3518 18.85H21.147L21.9587 10.05L21.6073 9.41667H24.4058Z"
        fill="black"
      />
      <path
        d="M33.5781 9.88333L32.7786 17.65H31.4096L32.2092 9.88333H33.5781ZM35.9162 8.26667L34.8138 19.1C34.7815 19.4111 34.6765 19.6389 34.4988 19.7833C34.3211 19.9167 34.1192 19.9833 33.8931 19.9833H32.0638L33.1057 18.55L34.099 8.85L33.8083 8.26667H35.9162ZM25.2434 19.85L26.0187 12.2H31.1189L30.7312 16C30.6989 16.3111 30.6383 16.5222 30.5495 16.6333C30.4687 16.7444 30.3113 16.8 30.077 16.8H27.8964L28.9019 15.6667L29.1079 13.6167H27.739L27.2907 18.0167H30.7918L31.2643 17.55L31.0341 19.85H25.2434ZM27.424 8.5L27.1696 8.03333H30.6949L31.6035 12.0167H29.6409L28.9625 9.65H28.8777L27.7268 12.0167H25.6674L27.424 8.5Z"
        fill="black"
      />
      <path
        d="M40.6036 8.41667L40.3492 8H42.5298L42.2754 9.26667H47L46.8425 10.85H44.2985L44.1168 12.6H46.2004L46.043 14.1667H43.9593L43.7776 15.9167H46.0914L45.9339 17.5H43.6201L43.3657 20H41.1729L42.1058 10.85H41.9604L41.5848 12.75H39.7434L40.6036 8.41667ZM39.695 9.9L38.6531 20H36.4604L37.4417 10.5167L36.7269 10.7L36.9208 8.8L39.8888 8L39.695 9.9Z"
        fill="black"
      />
    </svg>
  )
}
